'use client';

import { useAtom } from '@reatom/npm-react';
import { BACKEND_API } from '@trwl/backend.api';
import { isAuthedAtom } from '@trwl/store/atoms';
import { fcmTokenAtom } from '@trwl/store/atoms/fcmToken';
import { PropsWithChildren, useEffect } from 'react';

export const FcmTokenProvider = ({ children }: PropsWithChildren) => {
  const [isAuth] = useAtom(isAuthedAtom);
  const [fcmToken] = useAtom(fcmTokenAtom);

  useEffect(() => {
    if (!isAuth || !fcmToken) return;

    BACKEND_API.FirebaseApi.save({
      fcmToken: fcmToken,
    });
  }, [isAuth, fcmToken]);

  return children;
};
